/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './SubHeaderStyles.css';

const SubHeader = ({ options, handleSelected, selectedOptions, isDisabled }) => {
  const [activeTab, setActiveTab] = useState();

  const handleActiveTab = (e) => {
    setActiveTab(e);
  };
  const overwriteStyles = { 
    cursor: isDisabled ? 'auto' : 'pointer', 
    backgroundColor: isDisabled ? 'white' : 'inherit' 
  }

  useEffect(() => {
    if (activeTab) {
      handleSelected(activeTab);
    }
  }, [activeTab]);
  useEffect(() => {
    if (options) {
      const findOptionTab = options.find((e) => e.label === selectedOptions);
      const choiseOptionTab = selectedOptions ? findOptionTab : options[0];
      setActiveTab(choiseOptionTab);
    }
  }, [selectedOptions]);

  return (
    <div className="moduleSubHeader">
      <div className="moduleHeader__row">
        <div className="moduleHeader__wrapper">
          <div className="moduleHeader__nav-group">
            <div className="horizontalNavigationShadow">
              <ul className="horizontalNavigation__list">
                {
                  options && options.map(
                    (opt) => (
                      <li
                        key={opt.index}
                        className={activeTab === opt
                          ? 'horizontalNavigation__list-item activeTab'
                          : 'horizontalNavigation__list-item'}
                      >
                        <button
                          style={overwriteStyles}
                          disabled={isDisabled}
                          type="button"
                          className="navigation__link navigation__link-toggle"
                          onClick={() => handleActiveTab(opt)}
                        >
                          <span className="navigation__link-text navigation__link-text-custom">
                            { opt.label }
                          </span>
                        </button>
                      </li>
                    ),
                  )
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SubHeader.propTypes = {
  options: PropTypes.array.isRequired,
  handleSelected: PropTypes.func.isRequired,
  selectedOptions: PropTypes.string,
  isDisabled: PropTypes.bool
};

SubHeader.defaultProps = {
  selectedOptions: undefined,
  isDisabled: false
};

export default SubHeader;
